/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
import { Form, Col, Row, Input, Table, Button, Modal } from "antd";
import { CreateRecallModal } from "./create-modal";
import { EditRecallModal } from "./edit-modal";
import { useState } from "react";
import {
  department,
  unitTSN,
  unitNB,
  unitDN,
} from "../../../../info-technology-process/data";
import { useSelector } from "../../../../../../store/store";
import type { ColumnsType } from "antd/es/table";
import { Routes } from "../../../../../../AppRoutes";
import { useHistory } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";
import { PlanningDepartmentRecallToolService } from "../../../../../../services/planning-department/recall-tool";
import { Upload, Checkbox } from "antd";
import type { UploadFile, UploadProps } from "antd/es/upload/interface";
import { IToolType } from "../../models";
import { HiOutlineTrash } from "react-icons/hi2";
import { eContent, formFields1 } from "../../constant/field-names";
import { getEnv } from "../../../../../../AppConfigs";
import { validatePhoneNumber } from "../../../../../../services/util";
import ExcelJS from "exceljs";
import { useExcelTemplate } from "../../../../../../components/input/arrayData/hooks/useExcelTemplate";
import { getTemplate } from "../../../../../../components/input/arrayData/excel-template";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../../components/styled-antd";
import * as _ from "lodash";
import { getEmployeeDetail } from "../../../../human-organization/summary-employee-request/utils/get-employee-detail";
import { useSoftwares } from "../../../../../../hook";
import { SystemCode, requestStatus } from "../../../../../../constants";
import { sendEmail } from "../../../../human-organization/summary-employee-request/utils/send-mail";
import { RenderApprover, RenderCreateFormButton, RenderHelper, RenderUnit } from "../../../../human-organization/summary-employee-request/utils/render-helper";
import { PATH } from "../../constant/path";

export function CreateRecallToolForm() {
  const [dataSource, setDataSource] = useState<any[]>([]);
  const history = useHistory();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [units, setUnits] = useState<any[]>([]);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [isMultiDelete, setIsMultiDelete] = useState(false);
  const [listDelete, setListDelete] = useState<number[]>([]);
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);
  const [departmentValue, setDepartmentValue] = useState("");

  const { getITLeadITHeadAssignee } = useSoftwares();

  const { exportFile } = useExcelTemplate();

  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.eDepartment) {
      
      setDepartmentValue(changedValues.eDepartment);

      const selectedDepartment = department.filter(
        (value) => value.value == changedValues.eDepartment
      )[0];

      if (selectedDepartment.id === 2) {
        setUnits(unitNB);
        form.setFieldValue("eUnit", null);
      } else if (selectedDepartment.id === 3) {
        setUnits(unitDN);
        form.setFieldValue("eUnit", null);
      } else if (selectedDepartment.id === 1) {
        setUnits(unitTSN);
        form.setFieldValue("eUnit", null);
      } else {
        setUnits([
          { value: selectedDepartment.id, label: selectedDepartment.value },
        ]);
        form.setFieldValue("eUnit", selectedDepartment.id);
      }

      form.setFieldsValue({
        eApprovedBy: null,
        pickedUser: null,
      });
    }
  };

  const employees = useSelector((state: any) => state.employee.employees).map(
    (value: any) => {
      return {
        ...value,
        label: value.Title + " | " + value.eMail,
        value: value.eMail + "|" + value.Title,
      };
    }
  );
  const mailtemplates = useSelector(
    (state: any) => state.systemMgmt.mailtemplates
  );

  const columns: ColumnsType<IToolType> = [
    {
      title: isMultiDelete ? (
        <Checkbox
          onClick={(e: any) => {
            if (e.target.checked) {
              setListDelete(_.range(0, dataSource.length));
            } else {
              setListDelete([]);
            }
          }}
        />
      ) : (
        ""
      ),
      dataIndex: "action",
      key: "action",
      render: (index: number) => {
        index = (currentPage - 1) * pageSize + index;

        if (isMultiDelete) {
          return (
            <Checkbox
              checked={listDelete.includes(index)}
              onChange={(e) => {
                if (e.target.checked) {
                  let newListDelete = [...listDelete, index];
                  setListDelete(newListDelete);
                } else {
                  let newListDelete = [...listDelete];
                  newListDelete = newListDelete.filter(
                    (value): any => value != index
                  );
                  setListDelete(newListDelete);
                }
              }}
            />
          );
        }

        return (
          <div className="flex">
            <EditRecallModal
              dataSource={dataSource}
              setDataSource={setDataSource}
              index={index}
            />

            <Button
              onClick={() => {
                if ((dataSource.length - 1) % 10 == 0) {
                  const NUM_PAGES = Math.ceil(dataSource.length / pageSize);

                  if (currentPage >= 2 && currentPage === NUM_PAGES) {
                    setCurrentPage(currentPage - 1);
                  }
                }

                setDataSource((prev: any) => {
                  return prev.filter(
                    (value: any, indexValue: number) => indexValue != index
                  );
                });
              }}
              className="ml-1"
            >
              <HiOutlineTrash
                size={20}
                className="cursor-pointer"
                color="#dc2626"
              />
            </Button>
          </div>
        );
      },
    },
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (index: number) => (
        <>{(currentPage - 1) * pageSize + index + 1}</>
      ),
    },
    {
      title: "Tên CCDC",
      dataIndex: eContent.toolName,
      key: eContent.toolName,
    },
    {
      title: "Mã CCDC",
      dataIndex: eContent.toolId,
      key: eContent.toolId,
    },
    {
      title: "ĐVT",
      dataIndex: eContent.Dram,
      key: eContent.Dram,
    },
    {
      title: "Số lượng",
      dataIndex: eContent.Quantity,
      key: eContent.Quantity,
    },
    {
      title: "Lý do",
      dataIndex: eContent.reason,
      key: eContent.reason,
    },
  ];

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: async (file) => {
      const workbook = new ExcelJS.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = async () => {
        const buffer: any = reader.result;
        const workbooks = await workbook.xlsx.load(buffer);

        let data: any[] = [];

        workbooks.eachSheet((sheet) => {
          sheet.eachRow((row: any) => {
            data.push([...row.values].filter((_, index) => index != 0));
          });
        });

        data = data.filter((_, index) => index != 0);

        const dataSource: any[] = [];

        for (const item of data) {
          if (!Array.isArray(item) || item.length != 5) {
            CreateNotification({
              title: "Import file thất bại",
              body: `Vui lòng download biểu mẫu và nhập đúng thông tin.`,
              icon: "/icons/error.png",
            });
            return;
          }

          dataSource.push({
            [eContent.toolName]: item[0],
            [eContent.toolId]: item[1],
            [eContent.Dram]: item[2],
            [eContent.Quantity]: item[3],
            [eContent.reason]: item[4],
          });
        }

        setDataSource((prev) => [...prev, ...dataSource]);

        setFileList([...fileList, file]);
      };

      return false;
    },
    fileList,
    showUploadList: false,
  };

  const onFinish = async (values: any) => {
    if (dataSource.length === 0) {
      CreateNotification({
        title: "Thất bại",
        body: `Chỉnh sửa thất bại.`,
        icon: "/icons/error.png",
      });
      return;
    }

    let initFields: any = {
      Title: "Thu hồi công cụ dụng cụ",
      eDepartment: values.eDepartment,
      eUnit: values.eUnit,

      eRequestStatus: requestStatus.submitted,

      eApprovedStatus: requestStatus.submitted,
      eApprovedByITLeadStatus: requestStatus.submitted,
      eApprovedByITHeadStatus: requestStatus.submitted,
      eAssigneeStatus: requestStatus.submitted,

      eApprovedBy:
        values.pickedUser && values.pickedUser != ""
          ? values.pickedUser.split("|")[0].toLowerCase()
          : values.eApprovedBy.split("|")[0].toLowerCase(),

      eApprovedByITLead: getITLeadITHeadAssignee(
        SystemCode.ETR
      ).eApprovedByITLead.split("|")[0],

      eApprovedByITHead: getITLeadITHeadAssignee(
        SystemCode.ETR
      ).eApprovedByITHead.split("|")[0],

      eAssignee: getITLeadITHeadAssignee(SystemCode.ETR).eAssignee.split(
        "|"
      )[0],
    };

    const resp = await PlanningDepartmentRecallToolService.addNewRequest({
      fields: {
        ...initFields,

        ePhoneNumber: values.ePhoneNumber,
        eContent: JSON.stringify(dataSource),
      },
    });

    sendEmail(
      resp,
      "ETA",
      `${
        values.pickedUser && values.pickedUser != ""
          ? values.pickedUser.split("|")[0].toLowerCase()
          : values.eApprovedBy.split("|")[0].toLowerCase()
      }|${
        getEmployeeDetail(
          values.pickedUser && values.pickedUser != ""
            ? values.pickedUser.split("|")[0].toLowerCase()
            : values.eApprovedBy.split("|")[0].toLowerCase(),
          employees,
          softwares
        )?.[0]?.Title
      }`,
      mailtemplates,
      "",
      siteUrl,
      "",
      true
    );

    CreateNotification({
      title: "Thành công",
      body: `Tạo phiếu yêu cầu thu hồi CCDC thành công`,
      icon: "/icons/success.png",
    });

    history.push(Routes.procedureRecallTool.path);
  };

  const siteUrl = getEnv("REACT_APP_APPROVER_RECALL_TOOL_PLANNING_DEPARTMENT");

  const downLoad = async () => {
    await exportFile(getTemplate("recall-tool"));
  };

  const confirmDelete = () => {
    if ((dataSource.length - listDelete.length) % 10 == 0) {
      const NUM_PAGES = Math.ceil(dataSource.length / pageSize);

      if (currentPage >= 2 && currentPage === NUM_PAGES)
        setCurrentPage(currentPage - 1);
    }

    let newDataSource = [...dataSource];
    newDataSource = newDataSource.filter(
      (_, index) => !listDelete.includes(index)
    );
    setDataSource(newDataSource);
    setListDelete([]);
    setIsMultiDelete(false);
  };

  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá các dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      onOk() {
        confirmDelete();
      },
    });
  };

  const pageSize = 10; // Number of rows per page
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <>
      <Form
        onFinish={onFinish}
        size="large"
        onValuesChange={onValuesChange}
        form={form}
      >
        <Row gutter={[32, 0]}>
          <RenderHelper fields={formFields1} mode="create" />
          <RenderUnit
            department={departmentValue}
            form={form}
            span={12}
            mode="create"
          />

          <Col span={12}>
            <StyledTitle level={5}>
              Số điện thoại <span className="text-danger">(*)</span>
            </StyledTitle>
            <Form.Item
              name="ePhoneNumber"
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (validatePhoneNumber(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Số điện thoại không hợp lệ.")
                    );
                  },
                }),
              ]}
            >
              <Input className="font-weight-normal" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col>
            <StyledTitle level={5}>
              Danh mục CCDC cần thu hồi <span className="text-danger">(*)</span>
            </StyledTitle>
          </Col>
        </Row>

        <Row>
          <Col>
            <CreateRecallModal
              dataSource={dataSource}
              setDataSource={setDataSource}
            />
          </Col>

          <Col>
            {!isMultiDelete && (
              <StyledButton
                bgColor="red"
                className="ml-3"
                type="primary"
                danger
                onClick={() => setIsMultiDelete(true)}
              >
                Chọn nhiều để xóa
              </StyledButton>
            )}

            {isMultiDelete && (
              <StyledButton
                className="ml-3"
                bgColor="green"
                onClick={() => {
                  setIsMultiDelete(false);
                  setListDelete([]);
                }}
              >
                Quay lại
              </StyledButton>
            )}

            {listDelete.length != 0 && (
              <StyledButton
                bgColor="red"
                className="ml-3"
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm();
                }}
              >
                Xóa dữ liệu đã chọn
              </StyledButton>
            )}
          </Col>

          <Col>
            <Upload {...props}>
              <StyledButton bgColor="blue" className="mx-3 ">
                Tải biểu mẫu
              </StyledButton>
            </Upload>
          </Col>

          <Col span={8}>
            <div className="mt-1">
              <a href="#" className="text-primar" onClick={downLoad}>
                Download biểu mẫu tại đây
              </a>
            </div>
          </Col>
        </Row>

        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={{
            onChange: (page) => {
              setCurrentPage(page);
            },
            current: currentPage,
          }}
          scroll={{
            x: "100vh",
          }}
        />

        <Row gutter={[32, 0]}>
          <RenderApprover department={departmentValue} form={form} />
          <RenderCreateFormButton homePath={PATH.HOME} />
        </Row>
      </Form>
    </>
  );
}
